import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Shield, AlertCircle, CheckCircle } from 'lucide-react';

const TermsLoyalty = () => {
  return (
    <div className="min-h-screen bg-slate-50 font-sans">
      <Header />
      
      <div className="container mx-auto px-4 py-24 max-w-4xl">
        <div className="bg-white rounded-3xl p-8 shadow-sm border border-slate-200">
          <div className="flex items-center gap-3 mb-6">
            <div className="p-3 bg-blue-50 rounded-full">
                <Shield className="text-blue-600" size={32} />
            </div>
            <h1 className="text-2xl font-black text-slate-900 uppercase tracking-tighter">
              Conditions du Programme "Forfeo Récompense"
            </h1>
          </div>

          <div className="space-y-6 text-sm text-slate-600 leading-relaxed">
            
            <div className="p-4 bg-blue-50 rounded-xl border border-blue-100 flex gap-3">
              <AlertCircle className="text-blue-600 shrink-0" size={20}/>
              <p><strong>Avis Important (Québec) :</strong> Ce document régit l'utilisation des points de fidélité sur la plateforme Forfeo Explore conformément à la Loi sur la protection du consommateur.</p>
            </div>

            <section>
              <h3 className="font-black text-slate-900 mb-2 text-lg">1. Nature des Points</h3>
              <p>Les "Points Forfeo" constituent une unité de mesure de gratification. Ils ne possèdent aucune valeur monétaire ("No Cash Value") et ne peuvent être échangés contre de l'argent comptant. Forfeo agit titre de mandataire technologique facilitant la gestion de la fidélité pour ses partenaires commerciaux.</p>
            </section>

            <section>
              <h3 className="font-black text-slate-900 mb-2 text-lg">2. Responsabilité des Échanges</h3>
              <p>Lorsqu'un utilisateur échange ses points contre un produit ou service (ex: une nuitée, un repas) :</p>
              <ul className="list-disc pl-5 mt-2 space-y-1 bg-slate-50 p-4 rounded-xl border border-slate-100">
                <li>Le contrat de service est formé exclusivement entre l'Utilisateur et l'Entreprise Partenaire.</li>
                <li><strong>Forfeo Explore décline toute responsabilité</strong> en cas de refus, de faillite ou d'incapacité de l'Entreprise Partenaire à honorer la récompense.</li>
                <li>L'utilisateur doit valider la disponibilité du service auprès de l'entreprise avant de générer son code d'échange (QR).</li>
              </ul>
            </section>

            <section>
              <h3 className="font-black text-slate-900 mb-2 text-lg">3. Expiration et Inactivité</h3>
              <p>Conformément à la législation québécoise, les points accumulés n'expirent pas à une date fixe tant que le compte reste actif. Toutefois, Forfeo se réserve le droit de fermer un compte jugé "Inactif" (aucune connexion pendant 12 mois consécutifs) et d'annuler les points associés, moyennant un préavis écrit de 30 jours.</p>
            </section>

            <section>
              <h3 className="font-black text-slate-900 mb-2 text-lg">4. Valeur d'Échange</h3>
              <p>Chaque Entreprise Partenaire détermine librement la valeur de ses services en points, en se basant sur les lignes directrices suggérées par Forfeo. Ces valeurs peuvent être modifiées par l'entreprise sans préavis pour les échanges futurs.</p>
            </section>

            <div className="mt-8 pt-6 border-t border-slate-100 text-center">
              <p className="text-xs text-slate-400">Dernière mise à jour : Janvier 2026 • Forfeo Explore Québec Inc.</p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsLoyalty;
